import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { NAV, PHONE, PHONE_TEL } from "../data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header data-testid="site-header" className={`site-header ${scrolled || open ? "is-scrolled" : ""}`}>
      <div className="brand-bar" />
      <div className="wrap flex items-center justify-between h-20">
        <a href="#topo" data-testid="nav-logo-sr" className="flex items-center gap-3">
          <img src="/img/mark.webp" alt="SR Soluções Elétrica" width="51" height="44" className="h-11 w-auto blend" />
          <span className="font-display uppercase leading-none tracking-wide">
            <span className="block text-lg font-bold">SR Soluções</span>
            <span className="block text-[11px] tracking-[0.35em] text-[var(--red)]">Elétrica</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} data-testid={`nav-link-${n.id}`} className="nav-link">{n.label}</a>
          ))}
          <a href={`tel:${PHONE_TEL}`} data-testid="nav-phone-btn" className="btn btn-red !py-2.5 !px-5">
            <Phone size={16} /> {PHONE}
          </a>
        </nav>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden wrap pb-6 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${n.id}`} className="nav-link text-lg">{n.label}</a>
          ))}
        </nav>
      )}
    </header>
  );
};
